module.exports = __webpack_public_path__ + "ef3be7cbf71a50897952d4afbdffe874.png";